/* eslint-disable */
import React from "react";
import PaperComponent from "../../components/PaperComponent/PaperComponent";
import System from "../../components/System/System";

export default function SystemPage() {
  return <PaperComponent children={<System />} />;
}
